import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import Head from 'next/head';
// import loadjs from 'loadjs';
import { wrapper } from '~/store';
import nextI18nextConfig from '~/../next-i18next.config';
import Layout from '~/containers/Layout';
import CreatorProfileContainer from '~/containers/CreatorProfilePage';
import { makeSelectProfile } from '~/containers/CreatorProfilePage/selectors';
import defaultPage, {
  defaultPageServerSideContext,
} from '~/../hocs/defaultPage';
import { loadCreatorProfile } from '~/containers/CreatorProfilePage/actions';
import config from '~/config';
import { throw404 } from '~/utils/redirect';
import { loadPinterest } from '~/utils/file-helper';
import ErrorPage from '~/containers/ErrorPage';

const mapStateToProps = createStructuredSelector({
  profile: makeSelectProfile(),
});
@connect(mapStateToProps)
@defaultPage()
class CreatorProfilePage extends React.Component {
  componentDidMount() {
    loadPinterest();
  }

  render() {
    const { t, query, creator_id, lng, profile, throw404Page } = this.props;
    if (!profile) {
      return throw404();
    }

    //temporary set 404 for page
    if (throw404Page) {
      return throw404();
    }

    const creatorName =
      profile &&
      (profile.nickname_for_overseas || profile.name || profile.nickname);
    console.log('profile luc lay ra ne', profile.public_data);
    const public_data = profile?.public_data;
    return (
      <>
        {public_data === 1 ? (
          <Layout>
            <Head>
              <title>
                {t(
                  config.getPrefixContent('title_creator_profile_page_seo'),
                  // , {
                  //   creatorName,
                  // }
                )}
              </title>
              <meta
                id="meta-keywords"
                name="keywords"
                content={t(
                  config.getPrefixContent(
                    'meta_keywords_creator_profile_page_seo',
                  ),
                  // { creatorName },
                )}
              />
              {/* block search engine index page creator */}
              <meta name="robots" content="noindex" />
              <meta
                id="meta-description"
                name="description"
                content={t(
                  config.getPrefixContent(
                    'meta_description_creator_profile_page_seo',
                  ),
                  // { creatorName },
                )}
              />
            </Head>
            <CreatorProfileContainer
              query={query}
              creator_id={creator_id}
              lng={lng}
            />
          </Layout>
        ) : (
          <ErrorPage statusCode={404} />
        )}
      </>
    );
  }
}
export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['common'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      clientIp,
      api,
      sessionId,
      ssoToken,
      res,
      query: { creator_id, ...query },
    } = await defaultPageServerSideContext({
      ...ctx,
      store,
    });

    store.dispatch(
      loadCreatorProfile(
        {
          creator_id: creator_id,
          page: query.page || 1,
          max_results: query['item_per_page'] || 100,
          data_type: query.data_type || 'popular',
          createdAt: query.createdAt || null,
          download: query.download || null,
          lang: currentLanguage,
          clientIp,
        },
        api,
      ),
    );

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    const creatorProfile = makeSelectProfile()(store.getState());

    //temporary set 404 for page

    // if (!creatorProfile) {
    res.statusCode = 404;
    // }

    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
        creator_id,
        throw404Page: true,
      },
    };
  },
);

export default CreatorProfilePage;
